import { SVGProps, memo } from 'react';
const GenerateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || '16'}
    height={props.height || '16'}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='stars'>
      <path
        id='Star 6'
        d='M5.41476 0.378688C5.46795 0.24342 5.65938 0.24342 5.71257 0.378688L7.03961 3.75359C7.05668 3.79699 7.09184 3.83079 7.13588 3.84613L10.6935 5.0853C10.8367 5.13516 10.8367 5.33763 10.6935 5.38749L7.13588 6.62665C7.09184 6.64199 7.05668 6.67579 7.03961 6.7192L5.71257 10.0941C5.65938 10.2294 5.46795 10.2294 5.41476 10.0941L4.08773 6.7192C4.07066 6.67579 4.0355 6.64199 3.99145 6.62665L0.433803 5.38749C0.29064 5.33763 0.290641 5.13516 0.433803 5.0853L3.99145 3.84613C4.0355 3.83079 4.07066 3.79699 4.08773 3.75359L5.41476 0.378688Z'
        fill='black'
        fillOpacity='0.56'
      />
      <path
        id='Star 7'
        d='M11.4515 7.36403C11.5056 7.23113 11.6938 7.23113 11.7479 7.36403L12.7606 9.85162C12.7781 9.89476 12.8136 9.9281 12.8578 9.94295L15.549 10.8484C15.6943 10.8973 15.6943 11.1028 15.549 11.1517L12.8578 12.0571C12.8136 12.0719 12.7781 12.1053 12.7606 12.1484L11.7479 14.636C11.6938 14.7689 11.5056 14.7689 11.4515 14.636L10.4389 12.1484C10.4213 12.1053 10.3858 12.0719 10.3417 12.0571L7.65046 11.1517C7.50515 11.1028 7.50515 10.8973 7.65046 10.8484L10.3417 9.94295C10.3858 9.9281 10.4213 9.89476 10.4389 9.85162L11.4515 7.36403Z'
        fill='black'
        fillOpacity='0.56'
      />
    </g>
  </svg>
);

export default memo(GenerateIcon);
